<script>
import TablePage from '@/found/components/table_page';
import Form from './form/form.vue';
import EditForm from './editForm/form.vue';

export default {
  extends: TablePage,
  components: {
    Form,
    EditForm,
  },
  data() {
    return {

    };
  },
  mounted() {
    this.getConfigList('main_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add') {
        this.formName = 'Form';
        this.modalConfig.title = '新增';
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.openModal();
      }
      if (val.code === 'edit') {
        this.formName = 'EditForm';
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '编辑';
        this.openFull();
      }
      if (val.code === 'view') {
        this.formName = 'EditForm';
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '查看';
        this.openFull();
      }
    },
  },
};
</script>
